import { Directive, ElementRef, forwardRef, HostBinding, HostListener } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, ValidationErrors, Validator } from '@angular/forms';

import timezones from '../timezones';

@Directive({
  selector: 'input[appTimezone]',
  providers: [{
    provide: NG_VALIDATORS,
    useExisting: forwardRef(() => TimezoneFieldDirective),
    multi: true
  }]
})
export class TimezoneFieldDirective implements Validator {

  @HostBinding('attr.autocomplete') autocomplete = 'off';

  constructor(private field: ElementRef<HTMLInputElement>) {}

  // Zaznaczenie sprawia, że pierwsza wpisana litera zastępuje całą strefę, zamiast doklejać się do niej.
  @HostListener('focus')
  selectValue() {
    this.field.nativeElement.select();
  }

  @HostListener('blur')
  canonicalizeValue() {
    const input = this.field.nativeElement;
    const typed = input.value.trim().toLowerCase();
    const canonical = timezones.find(zone => zone.toLowerCase() === typed);

    if (!canonical || canonical === input.value) {
      return;
    }

    input.value = canonical;
    input.dispatchEvent(new Event('input'));
  }

  validate(control: AbstractControl): ValidationErrors | null {
    // Pustą przepuszczamy: kolumna timezone jest nullable, więc konto bez strefy istnieje i musi dać się zapisać.
    if (!control.value) {
      return null;
    }
    return timezones.indexOf(control.value) === -1 ? { timezoneInvalid: true } : null;
  }
}
